import { Language, uiTranslations, UIContent } from './uiTranslations';

class LanguageManager {
    private currentLang: Language = 'en';
    private listeners: ((lang: Language) => void)[] = [];

    constructor() {
        // Load from local storage or detect browser language
        const savedLang = localStorage.getItem('mercury_lang') as Language;
        if (savedLang && uiTranslations[savedLang]) {
            this.currentLang = savedLang;
        } else {
            // Detect browser language
            const browserLang = navigator.language;
            if (browserLang.includes('zh-HK') || browserLang.includes('zh-TW')) {
                this.currentLang = 'zh-HK';
            } else if (browserLang.includes('zh')) {
                this.currentLang = 'zh-CN';
            } else if (browserLang.includes('ja')) {
                this.currentLang = 'ja';
            } else if (browserLang.includes('ko')) {
                this.currentLang = 'ko';
            } else if (browserLang.includes('es')) {
                this.currentLang = 'es';
            }
        }
    }

    public getLanguage(): Language {
        return this.currentLang;
    }

    public setLanguage(lang: Language): void {
        if (this.currentLang === lang) return;

        this.currentLang = lang;
        localStorage.setItem('mercury_lang', lang);
        this.notifyListeners();
    }

    public getUI(): UIContent {
        return uiTranslations[this.currentLang];
    }

    public subscribe(listener: (lang: Language) => void): void {
        this.listeners.push(listener);
        // Immediately notify new subscriber with current state
        listener(this.currentLang);
    }

    public unsubscribe(listener: (lang: Language) => void): void {
        this.listeners = this.listeners.filter(l => l !== listener);
    }

    private notifyListeners(): void {
        this.listeners.forEach(listener => listener(this.currentLang));
    }
}

export const languageManager = new LanguageManager();
